/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';
import Loader from '../../Common/Loader';
import axios from 'axios';
import constants from '../../../constants';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
// import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
// const AsyncTypeahead = asyncContainer(Typeahead);
const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const MarkupDaywise = () => {
  const [ota, setOta] = useState([]);
  const [list, setList] = useState([]);
  const [showUILoader, setShowUILoader] = useState(false);
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [total, setTotal] = useState(0);
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [hotelList, setHotelList] = useState([]);
  const [date, setDate] = useState('');
  const [status, setStatus] = useState('1');
  const [searchParam, setSearchParam] = useState({ hotelName: '', hotelId: '', channelId: '' });
  const typeaheadRef = useRef();

  useEffect(() => {
    getOTAList();
    // eslint-disable-next-line
  }, []);

  const getOTAList = () => {
    axios(serverUrl + 'common/getotalist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    })
      .then(response => {
        if (response.status === 200) {
          setOta(response.data);
        } else {
          setMessageWithTimeout('error', 'Could not fetch ota list');
        }
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const validateFilters = () => {
    if (searchParam.hotelId === '') {
      setMessageWithTimeout('error', 'Please select hotel');
      return false;
    }
    if (searchParam.channelId === '') {
      setMessageWithTimeout('error', 'Please select channel/OTA');
      return false;
    }
    return true;
  };

  const getMarkup = () => {
    axios(serverUrl + 'channel/hotel_markup', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId: searchParam.hotelId,
        page: pageNumber,
        limit: limit,
        date: date,
        status: status,
        channel_id: searchParam.channelId
      }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setList(response.data.data);
          setTotal(response.data.count);
        } else {
          setMessageWithTimeout('error', response.data.message);
          setList([]);
          setTotal(0);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const setMessageWithTimeout = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => {
      setFlag(false);
    }, 3000);
  };

  const handlePageChange = pageNum => {
    setPageNumber(pageNum);
    setTimeout(() => {
      getMarkup();
    }, 0);
  };

  const handleSearch = hotel => {
    if (typeof hotel === 'undefined' || hotel === '') {
      return;
    }
    if (hotel.length > 2) {
      getHotelList(hotel);
    }
  };

  const getHotelList = hotel => {
    setShowSearchLoader(true);
    axios(serverUrl + 'property/gethotellisting', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { param: { page: 1, limit: 10, hotelName: hotel } }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setHotelList(response.data.data.list);
        } else {
          setMessageWithTimeout('error', response.data.message);
        }
        setShowSearchLoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowSearchLoader(false);
      });
  };

  const paramChange = (e, type) => {
    const newSearch = { ...searchParam };
    if (type === 'hotelName') {
      newSearch[type] = e.length > 0 ? e[0].hotel : '';
      newSearch['hotelId'] = e.length > 0 ? e[0].hotel_id : '';
    } else {
      newSearch[type] = e.target.value;
    }
    setSearchParam(newSearch);
  };

  const reset = () => {
    if (typeaheadRef.current) typeaheadRef.current.clear();
    setList([]);
    setDate('');
    setStatus('1');
    setTotal(0);
    setSearchParam({ hotelName: '', hotelId: '', channelId: '' });
  };

  const renderCSVlist = () => {
    if (Object.keys(list).length > 0) {
      return Object.keys(list).map(id => {
        var data = list[id];
        var autoNumber = parseInt(id) + 1 + (pageNumber - 1) * limit;
        return (
          <div className="table_row border_t_1 border_color_1" key={id}>
            <div className="tabcel align_middle pad10">{autoNumber}</div>
            <div className="tabcel align_middle pad10">{data.ota_model_name}</div>
            <div className="tabcel align_middle pad10">{data.hotel_code} </div>
            <div className="tabcel align_middle pad10">{data.category_code}</div>
            <div className="tabcel align_middle pad10">BAR</div>
            <div className="tabcel align_middle pad10">{data.channel_hotel_id}</div>
            <div className="tabcel align_middle pad10">{data.channel_category_id}</div>
            <div className="tabcel align_middle pad10">{data.channel_rate_plan_id}</div>
            <div className="tabcel align_middle pad10">{data.percentage_markup}</div>
            <div className="tabcel align_middle pad10">{data.flat_markup}</div>
            <div className="tabcel align_middle pad10">{data.date}</div>
            <div className="tabcel align_middle pad10">{data.status ? 'Active' : 'Inactive'}</div>
          </div>
        );
      });
    }
  };

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot10 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Date wise markup</div>
          </div>
        </div>
      </div>
      {flag ? (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>{message}</div>
      ) : (
        ''
      )}
      <div className="container_fluid pad_lft_rht20 padtop25">
        <div className="row gutters-5">
          <div className="col-xs-12 col-md marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              <AsyncTypeahead
                ref={typeaheadRef}
                inputProps={{ className: 'inputs' }}
                multiple={false}
                isLoading={showSearchLoader}
                options={hotelList}
                id={'hotel'}
                labelKey={'hotel'}
                minLength={3}
                align="justify"
                onSearch={handleSearch}
                placeholder={'Hotel'}
                filterBy={['hotel', 'hotel_code']}
                selectHintOnEnter
                onChange={selected => {
                  paramChange(selected, 'hotelName');
                }}
                renderMenuItemChildren={(option, props) => (
                  <span key={option.hotel_id} id={option.hotel_id}>
                    {option.hotel}
                  </span>
                )}
              />
            </div>
          </div>
          {/* Ota */}
          <div className="col-xs-12 col-md-2 marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              {' '}
              <span className="ficon pad_lft_rht10">
                <i className="fa fa-chevron-down"></i>
              </span>
              <select
                className="input pad_lft_rht10"
                value={searchParam.channelId}
                onChange={e => paramChange(e, 'channelId')}
              >
                <option value="">OTA</option>
                {Object.keys(ota).length > 0
                  ? Object.keys(ota).map(id => {
                      var data = ota[id];
                      return (
                        <option value={data.channel_id} key={id}>
                          {data.ota_name}
                        </option>
                      );
                    })
                  : ''}
              </select>
            </div>
          </div>
          {/* Date Input */}
          <div className="col-xs-12 col-md marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              <input
                type="date"
                className="inputs"
                value={date}
                onChange={e => setDate(e.target.value)}
              />
            </div>
          </div>
          {/* Status Dropdown */}
          <div className="col-xs-12 col-md marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              <select
                className="inputs"
                value={status}
                onChange={e => setStatus(e.target.value)}
              >
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>
          <div className="col-xs-12 col-md-auto marg_bottom10">
            <div
              className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc"
              onClick={() => {
                if (validateFilters()) {
                  getMarkup();
                }
              }}
            >
              {' '}
              <i className="fa fa-filter marg_right7"></i>Filter
            </div>
          </div>
          <div className="col-xs-12 col-md-auto marg_bottom10">
            <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc" onClick={reset}>
              {' '}
              <i className="fa fa-repeat marg_right7"></i>Reset
            </div>
          </div>
        </div>
        <div className="cover border_all_1 border_color_1 text-start">
          <div className="scrolly_auto">
            <div className="table_col table_fixed">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx60">S.No.</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Channel Name</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx170">Reddoorz Hotel Code</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx170">Reddoorz Category Code</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx170">Reddoorz Rateplan Id</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Channel Hotel Id</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx160">Channel Category Id</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx160">Channel Rateplan Id</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx120">Rate Markup(%)</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx140">Rate Markup(Flat)</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Date</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx80">Status</div>
              </div>
              {renderCSVlist()}
            </div>
          </div>
          {total === 0 && !showUILoader ? (
            <div className="cover pad30 border_t_1 border_color_1">
              <div className="ovr tc marg_bottom10">
                <div className="inline">
                  <img src="/images/no_result.png" alt="No Markup Found" />
                </div>
              </div>
              <div className="ovr tc fnt16 bld">No result Found</div>
            </div>
          ) : (
            ''
          )}
        </div>
        {total > limit ? (
          <div className="cover tc margtop15">
            {/* <Pagination
              activePage={pageNumber}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
            /> */}
          </div>
        ) : (
          ''
        )}
      </div>
    </React.Fragment>
  );
};

export default MarkupDaywise;
